<template>
  <div v-if="data.length > 0" class="file-list">
    <div class="ware-files">
      <div
        class="ware-file"
        :class="'ware-file-' + item.type"
        v-for="(item, index) in data"
        :key="index"
        @click="onPreview(item)"
      >
        <div
          class="ware-file_icon"
          :class="{ ['ware-file_icon-' + item.type]: true }"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Filelist",
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    fileList: {
      immediate: true,
      deep: true,
      handler(value) {
        this.data = [...value];
        this.getChildren();
      },
    },
  },
  data() {
    return {
      records: [],
      data: [],
    };
  },
  methods: {
    getChildren() {
      this.data.forEach(f => {
        if (
          /\.(wma|mp4|aac|flac|m4a|oga|opus|3gp|mpg|mpeg|3g2|avi|flv|h264|m4v|mj2|mov|ogg|ogv|rm|rmvb|qt|webm)$/i.test(
            f.ware_url,
          )
        ) {
          f.type = "video";
        } else if (/\.(doc|docx)$/i.test(f.ware_url)) {
          f.type = "word";
        } else if (/\.(xls|xlsx)$/i.test(f.ware_url)) {
          f.type = "excel";
        } else if (/\.(pdf)$/i.test(f.ware_url)) {
          f.type = "pdf";
        } else if (/\.(ppt|pptx)$/i.test(f.ware_url)) {
          f.type = "ppt";
        } else if (/\.(zip)$/i.test(f.ware_url)) {
          f.type = "zip";
        } else if (/\.(mp3|wav|wmv)$/i.test(f.ware_url)) {
          f.type = "audio";
        } else {
          f.type = "file";
        }
      });
    },
    onFileClick(file) {
      if (!file.ware_url) {
        return;
      }
      window.open(file.ware_url);
    },
    async onPreview(file) {
      if (
        file.ware_type == "video" ||
        file.ware_type == "audio" ||
        file.ware_type == 3
      ) {
        let data = await this.$http.get(
          "/api/app/user/CourseWare/video/preview",
          {
            video_id: file.fid,
          },
        );
        window.open(data[0].url);
      } else {
        let data = await this.$http.get("/api/app/user/CourseWare/preview", {
          fid: file.fid,
        });
        window.open(data);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.ware-files {
  padding-right: 20px;
  display: flex;
  padding-top: 12px;
}
.ware-file {
  width: 86px;
  height: 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 12px 0 0;
  border-radius: 30px;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }
}
.ware-file-pdf {
  background: rgba(255, 90, 118, 0.1);
}
.ware-file-video {
  background: rgba(74, 141, 255, 0.1);
}
.ware-file-audio {
  background: rgba(255, 156, 85, 0.1);
}
.ware-file_icon {
  width: 22px;
  height: 22px;
  background-size: 100% 100%;
}
.ware-file_icon-file {
  background-image: url("~@/modules/stu/images/file/file_icon_3@2x.png");
}
.ware-file_icon-excel {
  background-image: url("~@/modules/stu/images/file/xlsx_icon@2x.png");
}
.ware-file_icon-pdf {
  background-image: url("~@/modules/stu/images/file/pdf_icon@2x.png");
}
.ware-file_icon-ppt {
  background-image: url("~@/modules/stu/images/file/ppt_icon@2x.png");
}
.ware-file_icon-video {
  background-image: url("~@/modules/stu/images/file/video_icon_1@2x.png");
}
.ware-file_icon-word {
  background-image: url("~@/modules/stu/images/file/doc_icon@2x.png");
}
.ware-file_icon-zip {
  background-image: url("~@/modules/stu/images/file/zip@2x.png");
}
.ware-file_icon-audio {
  background-image: url("~@/modules/stu/images/file/audio_icon@2x.png");
}
</style>
